import React, { Component } from "react";
//import "../login/style.scss";
import { Cookies } from "react-cookie";
import { Redirect, Link } from "react-router-dom";
import { observer } from "mobx-react";
import UserStore from "../../stores/UserStore";
import Inner from "../template/Inner";
import AppStore from "../../stores/AppStore";
import api from "../../lib/api";
import Spinner from "react-spinkit";

@observer
class UserSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logout: false,
      key: null,
      error: false,
      brokerage_name: "",
      dmca_link: ""
    };
  }

  componentDidMount() {}

  copyToClipboard = e => {
    this.copyLink.select();
    document.execCommand("copy");
    window.showToastMessage("Success", "API key copied to clipboard");
  };

  render() {
    if (UserStore.isAdmin()) {
      return <Redirect to="/settings" />;
    }

    if (this.state.error) {
      return (
        <Inner>
          <div class="content">
            <div className="centerBox">
              <img src="https://bk.homestack.com/assets/img/not-found.svg" />
              <h2>Unable to load data</h2>
              <p>
                <button
                  onClick={() => {
                    this.setState({ error: false });
                    this.load();
                  }}
                >
                  Try again
                </button>
              </p>
            </div>
          </div>
        </Inner>
      );
    }

    if (!UserStore.user.agent_data.api_key) {
      return (
        <Inner>
          <div class="bg-dark bg-dots m-b-30">
            <div class="container">
              <div class="row p-b-60 p-t-60">
                <div class="col-lg-8 text-center mx-auto text-white p-b-30">
                  <div class="m-b-10">
                    <div class="avatar avatar-lg ">
                      <div class="avatar-title bg-info rounded-circle mdi mdi-settings " />
                    </div>
                  </div>
                  <h3>Settings &amp; Integrations</h3>
                </div>
              </div>
            </div>
          </div>

          <section class="pull-up">
            <div class="container">
              <div class="row ">
                <div class="col-lg-6">
                  <div class="card py-3 m-b-30">
                    <div class="card-body">
                      <h3 class="">API key not available</h3>

                      <p>
                        There is no API key for this account. If you believe
                        this is in error, please contact support.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Inner>
      );
    }

    return (
      <Inner>
        <div class="bg-dark bg-dots m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-lg-8 text-center mx-auto text-white p-b-30">
                <div class="m-b-10">
                  <div class="avatar avatar-lg ">
                    <div class="avatar-title bg-info rounded-circle mdi mdi-settings " />
                  </div>
                </div>
                <h3>Settings &amp; Integrations</h3>
              </div>
            </div>
          </div>
        </div>

        <section class="pull-up">
          <div class="container">
            <div class="row ">
              <div class="col-lg-6">
                <div class="card py-3 m-b-30">
                  <div class="card-body">
                    <h3 class="">API key</h3>

                    <div class="form-group">
                      <label for="api_key">Your API key</label>
                      <input
                        style={{ fontFamily: "monospace", fontSize: 16 }}
                        id="api_key"
                        type="text"
                        class="form-control"
                        ref={input => (this.copyLink = input)}
                        type="text"
                        value={UserStore.user.agent_data.api_key}
                      />
                    </div>

                    <div class="text-center">
                      <button
                        onClick={this.copyToClipboard}
                        class="btn btn-info btn-cta"
                      >
                        Copy API key
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="card py-3 m-b-30">
                  <div class="card-body">
                    <h3 class="">
                      Zapier <span class="badge badge-warning">beta</span>
                    </h3>

                    <div class="card-body">
                      <p>
                        You can get access to the HomeStack Zapier beta from:{" "}
                        <a
                          href="https://zapier.com/developer/public-invite/28937/ce9d7c0cead1b4ca460d46d7fd1c9b7b/"
                          target="_blank"
                          class="text-underline"
                        >
                          https://zapier.com/developer/public-invite/28937/ce9d7c0cead1b4ca460d46d7fd1c9b7b
                        </a>
                      </p>

                      <hr />

                      <p>
                        Read the{" "}
                        <a
                          class="text-underline"
                          href="/assets/docs/homestack-zapier-beta-guide.pdf"
                          target="_blank"
                        >
                          Zapier integration guide
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Inner>
    );

    return (
      <Inner>
        <div class="content">
          <div class="row">
            <div class="col-2">
              {UserStore.isAgent() && (
                <div class="content-block">
                  <h2>API key</h2>

                  <p>Your unique app API key. Keep this safe!</p>
                  <p>
                    <input
                      ref={input => (this.copyLink = input)}
                      type="text"
                      value={this.state.key}
                    />
                  </p>
                  <div class="row">
                    <p>
                      <button onClick={this.copyToClipboard}>
                        Copy API key
                      </button>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Inner>
    );
  }
}

export default UserSettings;
